var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"slider-rgb-canvas"},[_c('v-color-picker',{attrs:{"value":_vm.sliderValue,"flat":"","hide-inputs":"","hide-mode-switch":"","disabled":_vm.isDisabled},on:{"input":_vm.handleState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }